import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { AI_UTILITIES } from './constants/aiUtilities';
import {
    PrivateRoute,
    AuthProvider,
    SignalRProvider,
    Layout,
    Home,
    UserResults,
    Auth,
    AdminPanel,
    StatisticsPage,
    NotificationProvider
} from './components';
import { Notification } from './components/Notification';
import { NotFound, NoAccess } from './error_pages';
import {
    Transcribe,
    StandardControlPSA,
    MarketPriceAnalysis,
    Diarize,
    SummarizeResume,
    UniversalSummarizeResume,
    DepersonalizeFileData,
    Retelling,
    InvoiceRecognizer
} from './ai';
import { ThemeProvider } from './components/hooks/useTheme';
import './custom.css';
import dayjs from 'dayjs';

dayjs.locale('ru');

export default class App extends Component {
    static displayName = 'App';

    render() {
        return (
            <ThemeProvider>
                <AuthProvider>
                    <SignalRProvider>
                        <NotificationProvider>
                            <Layout>
                                <Switch>
                                    <Route exact path="/auth" component={Auth} />
                                    <Route exact path="/no-access" component={NoAccess} />

                                    <PrivateRoute exact path='/' component={Home} requiredPermission={null} />
                                    <PrivateRoute path={AI_UTILITIES.TRANSCRIBE.path} component={Transcribe} requiredPermission={AI_UTILITIES.TRANSCRIBE.permission} />
                                    <PrivateRoute path={AI_UTILITIES.DIARIZE.path} component={Diarize} requiredPermission={AI_UTILITIES.DIARIZE.permission} />
                                    <PrivateRoute path={AI_UTILITIES.SUMMARIZE_RESUME.path} component={SummarizeResume} requiredPermission={AI_UTILITIES.SUMMARIZE_RESUME.permission} />
                                    <PrivateRoute path={AI_UTILITIES.UNIVERSAL_SUMMARIZE.path} component={UniversalSummarizeResume} requiredPermission={AI_UTILITIES.UNIVERSAL_SUMMARIZE.permission} />
                                    <PrivateRoute path={AI_UTILITIES.DEPERSONALIZE.path} component={DepersonalizeFileData} requiredPermission={AI_UTILITIES.DEPERSONALIZE.permission} />
                                    <PrivateRoute path={AI_UTILITIES.RETELLING.path} component={Retelling} requiredPermission={AI_UTILITIES.RETELLING.permission} />
                                    <PrivateRoute path={AI_UTILITIES.STANDARD_CONTROL_PSA.path} component={StandardControlPSA} requiredPermission={AI_UTILITIES.STANDARD_CONTROL_PSA.permission} />
                                    <PrivateRoute path={AI_UTILITIES.MARKET_PRICE_ANALYSIS.path} component={MarketPriceAnalysis} requiredPermission={AI_UTILITIES.MARKET_PRICE_ANALYSIS.permission} />
                                    <PrivateRoute path={AI_UTILITIES.INVOICE_RECOGNIZER.path} component={InvoiceRecognizer} requiredPermission={AI_UTILITIES.INVOICE_RECOGNIZER.permission} />
                                    <PrivateRoute path='/myresults' component={UserResults} requiredPermission={null} />
                                    <PrivateRoute path='/statistics' component={StatisticsPage} requiredPermission="org_statistics_access" />
                                    <PrivateRoute path='/admin' component={AdminPanel} requiredPermission="aiferma_main_admin_access" />
                                    <PrivateRoute path='/notifications' component={Notification} requiredPermission={null} />

                                    <Route component={NotFound} />
                                </Switch>
                            </Layout>
                        </NotificationProvider>
                    </SignalRProvider>
                </AuthProvider>
            </ThemeProvider>
        );
    }
}